
import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import * as agui from 'arm-gui/dist/controls';
import MicroCategorieActions from './microCaterogieActions';
import { i18n, Utils, domain, domainVal, isAuth, NumberFormatter, DateFormatter, opt } from 'arm-common';
import GaranzieTable from '../garanzie/garanzieTable.jsx';
import GaranzieActions from '../garanzie/garanzie_actions'
import { resolve } from 'dns';
import UploadImage from './uploadImage.jsx'
import Rest from '../../webapi/Rest';
import ContraentiTable from './ContraentiTable.jsx'
import SwitchButton from '../shared/switchButtonV4.jsx';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import TipoPropostaTable from './TipoPropostaTable.jsx'
import { ConfirmModalSaveV4 } from '../shared/v4';

class MicroCategorieCreate extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MicroCategorieCreate.jsx] ';
        this.salvaGP = this.salvaGP.bind(this);
        this.cancelEditButton = this.cancelEditButton.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.removeGaranziaFromList = this.removeGaranziaFromList.bind(this);
        this.spostaSelectedRowGiu = this.spostaSelectedRowGiu.bind(this);
        this.spostaSelectedRowSu = this.spostaSelectedRowSu.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.nuovaGaranziaButton = this.nuovaGaranziaButton.bind(this);
        this.showConfirmPanelUpload = this.showConfirmPanelUpload.bind(this)
        this.changeSelectedTab = this.changeSelectedTab.bind(this);
        this.showConfirmPanelElimina = this.showConfirmPanelElimina.bind(this);
        this.deleteMicroCategoriaImmagine = this.deleteMicroCategoriaImmagine.bind(this);
        this.state = {
            validation: new Map(),
            showConfirm: false,
            showConfirmUpload: false,
        };
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        if (!this.props.location.state || !this.props.location.state.modifica) {
            if (!this.props.location.state
                || !this.props.location.state.famigliaProdottoOrigine) {
                this.props.inizializzaCreazioneGP();

                this.props.changeSelectedTab("home-tab");
            }
        } else {
            if (this.props.tabSelected !== 'contraenti-tab'
                && this.props.tabSelected !== 'garanzie-tab'
                && this.props.tabSelected !== 'tipoProposta-tab'
                && this.props.tabSelected !== 'home-tab') {
                this.props.changeSelectedTab("home-tab");
            }
            this.props.getListaGaranzie().then(
                resolve => {

                }
            )
        }
        this.props.inizializzaComboRami();
        this.props.getListaRamoSinistri();
    }

    cancelEditButton() {
        console.log(this.componentName + 'cancelEditButton');
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.history.push({ pathname: '/microCategorie/details', state: { id: this.props.location.state.id } });
        } else {
            this.props.history.goBack();
        }
    }

    changeSelectedTab(e) {
        if (e !== null && e !== undefined) {
            let idTab = e.target.id;
            this.props.changeSelectedTab(idTab);
        }
    }


    showConfirmPanel() {
        if (!this.props.showConfirm) {
            if (!this.validateForm()) {
                console.log('validateForm return false');
                this.props.showPopUP(false);
                return null;
            }
        }
        this.props.showPopUP(!this.props.showConfirm);
    }

    showConfirmPanelUpload() {
        this.setState({ showConfirmUpload: !this.state.showConfirmUpload })
    }

    removeGaranziaFromList(e) {
        let id = e.target.id;
        console.log(this.componentName + 'removeGaranziaFromList ' + id);
        this.props.removeSelectedRow(id);
    }

    spostaSelectedRowGiu(index) {
        console.log(this.componentName + 'spostaSelectedRowGiu ' + index);
        this.props.spostaSelectedRowGiu(index);
        this.setState({ showConfirm: false });
    }

    spostaSelectedRowSu(index) {
        console.log(this.componentName + 'spostaSelectedRowSu ' + index);
        this.props.spostaSelectedRowSu(index);
        this.setState({ showConfirm: false });
    }

    validateForm() {
        console.log(this.componentName + 'validateForm');

        let validation = new Map();
        let required = ['nome', 'idCategoriaProdotto', 'idFamigliaProdotto', 'codAmbito'];
        if (opt("APP", "FL_VIEW_TAB_RAMO", "false") === "true") {
            required.push('idRamoSinistri');
        }
        for (let i = 0; i < required.length; i++) {
            if (this.props.microCategorie[required[i]] === undefined || this.props.microCategorie[required[i]] === '' || this.props.microCategorie[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        this.setState({ showConfirm: !this.state.showConfirm })
        return false;
    }

    salvaGP() {
        console.log(this.componentName + 'salvaGP');

        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }
        this.props.showPopUP(false);
        this.props.salvaGP(this.props.history).then(
            resolve => {

            }, reject => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
            }
        );
    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }
            if (type === "date" && value !== undefined) {
                let data = new Date(value);
                value = data.getTime();
            }

            if (type === "number" && value === "") {
                value = null;
            }

            if (id === "idCategoriaProdotto" || id === "idFamigliaProdotto") {
                value = parseInt(value);
            }

            this.props.handleChange(id, value).then(
                resolve => {
                    if (id === "codAmbito" || id === "idFamigliaProdotto" || id === 'idCategoriaProdotto') {
                        if (id === "codAmbito") {
                            this.props.handleChange('idCategoriaProdotto', null);
                            this.props.handleChange('idFamigliaProdotto', null);
                        } else if (id === "idFamigliaProdotto") {
                            this.props.handleChange('idCategoriaProdotto', null);
                            this.props.impostaCampiSuperioriMicroCategorie('idFamigliaProdotto');
                        } else if (id === 'idCategoriaProdotto') {
                            this.props.impostaCampiSuperioriMicroCategorie('idCategoriaProdotto');
                        }
                        this.props.inizializzaComboRami();
                    }
                }
            )
        }
    }

    nuovaGaranziaButton() {
        console.log(this.componentName + "nuovaGaranziaButton:");

        this.props.inizializzaNuovaGaranziaDalGP().then(
            resolve => {
                this.props.history.push({ pathname: '/garanzie/create', state: { microCategoria: true } });
            },
            reject => {
                console.log(this.componentName + "nuovaGaranziaButton: KO");
            }
        )
    }
    arrayBufferToBase64(buffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    showConfirmPanelElimina() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete })
    }

    deleteMicroCategoriaImmagine() {
        this.showConfirmPanelElimina();
        this.props.deleteMicroCategoriaImmagine();
    }

    render() {
        console.log(this.componentName + 'render');

        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>
                        {this.props.location.state && this.props.location.state.modifica ?
                            <h3>    {i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.MODIFICA_DEL_MICRO_CATEGORIA', 'Modifica della micro-categoria')} {this.props.location.state.id}: {this.props.microCategorie && this.props.microCategorie.nome ? this.props.microCategorie.nome : null} </h3>
                            :
                            <h3>  {i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.CREAZIONE_NUOVO_MICRO_CATEGORIA', 'Creazione Nuova Micro-categoria')}</h3>
                        }
                    </agui.aCardV4Header>
                    <agui.aCardV4Body>
                        {this.props.location.state && this.props.location.state.modifica &&
                            <ul className="nav nav-tabs" id="myTab" role="tablist">

                                <li className={this.props.tabSelected === "home-tab" ? "active" : "nav-item"} >
                                    <a className={this.props.tabSelected === "home-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLI', 'Dettagli')}</a>
                                </li>
                                {isAuth('V2.ADMIN.PRODUCT.VIEW.GARANZIE') &&
                                    <li className={this.props.tabSelected === "garanzie-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "garanzie-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="garanzie-tab" data-toggle="tab" href="#garanzie" role="tab" aria-controls="garanzie" aria-selected="true">{i18n('ARM_CORE_PRODUCT.MENUTOP.GARANZIE', 'Garanzie')}</a>
                                    </li>}

                                <li className={this.props.tabSelected === "contraenti-tab" ? "active" : "nav-item"}>
                                    <a className={this.props.tabSelected === "contraenti-tab" ? "nav-link  active" : "nav-link "} id="contraenti-tab" onClick={this.changeSelectedTab} data-toggle="tab" href="#contraenti" role="tab" aria-controls="contraenti" aria-selected="true">{i18n('ARM_CORE_PRODUCT.MENUTOP.CONTRAENTI', 'Contraenti')}</a>
                                </li>

                                {isAuth('VIEW_TAB_MICROCATEGORIA_TIPO_PROPOSTA') &&
                                    <li className={this.props.tabSelected === "tipoProposta-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "tipoProposta-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="tipoProposta-tab" data-toggle="tab" href="#tipoProposta" role="tab" aria-controls="tipoProposta" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.TIPO_PROPOSTA', 'Tipo proposta')}</a>
                                    </li>
                                }

                            </ul>}
                        <div className="tab-content" id="myTabContent">
                            <div className={this.props.tabSelected === 'home-tab' ? 'tab-pane active' : 'tab-pane'} id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="nome" type="text"
                                            value={this.props.microCategorie.nome}
                                            placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_NOME', 'inserire nome')}
                                            required
                                            label={i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}
                                            validation={this.state.validation}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="descrizione" type="text"
                                            maxlength={255}
                                            value={this.props.microCategorie.descrizione}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_DESCRIZIONE', 'inserire descrizione')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ordVis" type="number"
                                            value={this.props.microCategorie.ordVis}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_ORDINE', 'inserire ordine')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4
                                            id="codQuestionarioAccettazione"
                                            onChange={this.inputChangeHandler}
                                            value={this.props.microCategorie.codQuestionarioAccettazione ? this.props.microCategorie.codQuestionarioAccettazione : ""}
                                            label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_ACCETTAZIONE', 'Questionario Accettazione')}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4
                                            id="codQuestionarioQuotazione"
                                            onChange={this.inputChangeHandler}
                                            value={this.props.microCategorie.codQuestionarioQuotazione ? this.props.microCategorie.codQuestionarioQuotazione : ""}
                                            label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_QUOTAZIONE', 'Questionario Quotazione')}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4
                                            id="codQuestionarioEmissione"
                                            onChange={this.inputChangeHandler}
                                            value={this.props.microCategorie.codQuestionarioEmissione ? this.props.microCategorie.codQuestionarioEmissione : ""}
                                            label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_EMISSIONE', 'Questionario Emissione')}
                                        />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    {domain("AI_AMBITO_RAMO") ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ASelectV4
                                                id="codAmbito"
                                                onChange={this.inputChangeHandler}
                                                value={this.props.microCategorie.codAmbito}
                                                validation={this.state.validation}
                                                required
                                                label={i18n('ARM_CORE_PRODUCT.SHARED.AMBITO', 'Ambito')}
                                                items={domain("AI_AMBITO_RAMO")}
                                                valueKey="valCampo"
                                                labelKey="desDom"
                                            />
                                        </div>
                                        : null}

                                    {opt("APP", "FL_VIEW_MICROCATEGORIA_PACCHETTO", "false") === "true" ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <SwitchButton
                                                id="microCategoriaPacchetto"
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.MICRO_CATEGORIA_PACCHETTO', 'Microcategoria pacchetto')}
                                                disabled={false}
                                                required
                                                value={this.props.microCategorie.microCategoriaPacchetto === "true" || this.props.microCategorie.microCategoriaPacchetto === true}
                                                componentClass="mt-3 col-sm-12 col-md-6 col-lg-6 mb-3"
                                                onChange={this.inputChangeHandler}
                                            />
                                        </div>
                                        : null
                                    }

                                    {opt("APP", "FL_VIEW_SINISTRO", "false") === "true" ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ATextInputV4
                                                id="codQuestionarioSinistro"
                                                onChange={this.inputChangeHandler}
                                                value={this.props.microCategorie.codQuestionarioSinistro}
                                                label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.SINISTRO', 'Questionario Sinistro')}
                                            />
                                        </div>
                                        : null}
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="idFamigliaProdotto"
                                            disabled={false}
                                            required
                                            onChange={this.inputChangeHandler}
                                            value={this.props.microCategorie.idFamigliaProdotto}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto')}
                                            items={this.props.gruppiRamoSelezionabili}
                                            validation={this.state.validation}
                                            valueKey="id"
                                            labelKey="nome"
                                        />
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="idCategoriaProdotto"
                                            disabled={false}
                                            required={true}
                                            validation={this.state.validation}
                                            onChange={this.inputChangeHandler}
                                            value={this.props.microCategorie.idCategoriaProdotto}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.CATEGORIA_PRODOTTO', 'Categoria Prodotto')}
                                            items={this.props.ramiSelezionabili}
                                            valueKey="id"
                                            labelKey="nome"
                                        />
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="dataFineAdesione" type="date"
                                            value={this.props.microCategorie.dataFineAdesione ? DateFormatter.formatDateFromMilisToString(this.props.microCategorie.dataFineAdesione) : ""}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.DATA_FINE_ADESIONE', 'Data Fine Adesione')}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                    {opt("APP", "FL_VIEW_TAB_RAMO", "false") === "true" &&
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ASelectV4
                                                id="idRamoSinistri"
                                                disabled={false}
                                                required={true}
                                                validation={this.state.validation}
                                                onChange={this.inputChangeHandler}
                                                value={this.props.microCategorie.idRamoSinistri}
                                                label={i18n('ARM_CORE_PRODUCT.SHARED.RAMO_SINISTRI', 'Ramo')}
                                                items={this.props.ramoSinistri}
                                                valueKey="id"
                                                labelKey="idConDenominazioneRamo"
                                            />
                                        </div>
                                    }
                                </div>

                                {isAuth('V2.ADMIN.PRODUCT.VIEW.FL_FINANZIARIA') &&
                                    <div className="row mt-4">
                                        <SwitchButton
                                            id="flFinanziaria"
                                            label={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.FLAG_FINANZIARIA', 'Flag finanziaria')}
                                            value={this.props.microCategorie.flFinanziaria === "true" || this.props.microCategorie.flFinanziaria === true}
                                            componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                            onChange={this.inputChangeHandler}
                                        />
                                    </div>
                                }

                                <div className="row mt-3 ml-1" style={{ alignItems: "flex-end" }}>

                                    {
                                        this.props.microCategorie.imagine ?
                                            <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className="col-12 col-lg-5 col-md-6 col-sm-12 mt-2 " sizes="50x32" rel="icon" src={this.props.microCategorie.imagine ? "data:image/png;base64," + this.props.microCategorie.imagine : ""} alt="Card image cap" />
                                            :
                                            this.props.microCategorie.imagePath ?
                                                <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className="col-12 col-lg-5 col-md-6 col-sm-12 mt-2 " sizes="50x32" rel="icon" src={this.props.microCategorie.imagePath ? Rest.createRestLink("document/download/" + this.props.microCategorie.imagePath) : ""} alt="Card image cap" />
                                                :
                                                <h6 className="mt-2">{i18n('ARM_CORE_PRODUCT.CREATE.MICRO.IMAGGE', 'Nessuna immagine legata a questa micro-categoria')}</h6>
                                    }
                                    <div className="col-4">
                                        <agui.aButton bs="primary" icon="fas fa-upload" onClick={this.showConfirmPanelUpload}>
                                            {this.props.microCategorie && this.props.microCategorie.imagine ?
                                                i18n('ARM_CORE_PRODUCT.SHARED.CAMBIA', 'Cambia') :
                                                i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD', 'Upload')}</agui.aButton>
                                        {this.props.microCategorie && this.props.microCategorie.imagine ?
                                            <agui.aButton bs="danger" className="ml-2" icon="fas fa-trash" onClick={this.showConfirmPanelElimina}>
                                                {i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</agui.aButton>
                                            : null
                                        }
                                    </div>
                                    <UploadImage idMicroCategoria={this.props.microCategorie.id} show={this.state.showConfirmUpload} close={this.showConfirmPanelUpload} inputChangeHandler={this.props.handleChange}

                                    />
                                </div>
                            </div>
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === 'garanzie-tab' ? 'tab-pane active' : 'tab-pane'} id="garanzie" role="tabpanel" aria-labelledby="garanzie-tab">
                                    <div className="ml-3 mt-4">
                                        <h3> {i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.GARANZIE_SEL', 'Garanzie selezionate')}</h3>
                                        <div className="mt-3">

                                            <table className="table table-bordered table-hover table-striped" >
                                                <thead>
                                                    <tr>
                                                        <td style={{
                                                            width: '4%'
                                                        }}></td>
                                                        <td></td>
                                                        <td>#</td>
                                                        <td>Id</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.GRUPPO_PRODOTTO.GARANZIE_SEL', 'Nome Garanzia')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.GARANZIE.BISOGNO', 'Bisogno')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.microCategorie.listaGaranzie.map((item, index) =>
                                                        <tr key={index}>
                                                            <td style={{
                                                                textAlign: 'center',
                                                                width: '4%'
                                                            }}>
                                                                {index === 0 ? null :
                                                                    <agui.aButton bs="info" title={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.SPOSTA_SU', 'Sposta Su')} id={item} icon="fas fa-caret-up" onClick={() => this.spostaSelectedRowSu(index)} ></agui.aButton>
                                                                }
                                                            </td>
                                                            <td style={{
                                                                width: '4%'
                                                            }}>
                                                                {index === this.props.microCategorie.listaGaranzie.length - 1 ? null :

                                                                    <agui.aButton bs="info" className="ml-1" title={i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.SPOSTA_GIU', 'Sposta Giù')} id={index} icon="fas fa-caret-down" onClick={() => this.spostaSelectedRowGiu(index)} ></agui.aButton>

                                                                }
                                                            </td>
                                                            <td> {item.ordine}</td>
                                                            <td>{item.garanzia.id}</td>
                                                            {isAuth('SHOW_SIGLA_GARANZIA_DETTAGLIO_MICROCATEGORIA') ?
                                                                <td>
                                                                    {item.garanzia.nome}
                                                                    <br></br>
                                                                    <em>{i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla')}</em>: <strong>{item.garanzia.sigla}</strong>
                                                                </td>
                                                                :
                                                                <td>{item.garanzia.nome}</td>
                                                            }
                                                            <td>{domainVal('AI_BISOGNO', item.garanzia.codBisogno, item.garanzia.codBisogno).desDom}</td>
                                                            <td>{domainVal('AI_RAMO_GARANZIA', item.garanzia.codRamo, item.garanzia.codRamo).desDom}</td>
                                                            <td> <agui.aButton bs="danger" id={item} icon="fas fa-trash-alt" onClick={() => this.props.removeSelectedRow(item)} ></agui.aButton> </td>

                                                        </tr>
                                                    )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        <h3> {i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.GARANZIE_SELEZIONABILI', 'Garanzie selezionabili')}</h3>
                                        <GaranzieTable rows={this.props.listaGaranzie} source="gpCreate" ></GaranzieTable>
                                    </div>

                                </div>}

                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === 'contraenti-tab' ? 'tab-pane active' : 'tab-pane'} id="contraenti" role="tabpanel" aria-labelledby="contraenti-tab">
                                    <ContraentiTable source="microCategoriaCreate" contraenti={this.props.contraenti} inizializzaModificaContraenti={this.props.inizializzaModificaContraenti}></ContraentiTable>
                                </div>
                            }
                            {isAuth('VIEW_TAB_MICROCATEGORIA_TIPO_PROPOSTA') &&
                                this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === 'tipoProposta-tab' ? 'tab-pane active' : 'tab-pane'} id="tipoProposta" role="tabpanel" aria-labelledby="tipoProposta-tab">
                                    <TipoPropostaTable source="microCategoriaCreate" tipoProposta={this.props.tipoProposta} inzializzaModificaTipoProposta={this.props.inzializzaModificaTipoProposta} />
                                </div>
                            }
                        </div>
                        <br></br>

                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.cancelEditButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4>
                <ConfirmModalSaveV4
                    testoTitle={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoBody={this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI.VOLER.SALV', 'Confermi di voler salvare?')}
                    testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    testoButtonCancel={i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    show={this.props.showConfirm}
                    saveOnClick={this.salvaGP}
                    onClose={this.showConfirmPanel} />

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteMicroCategoriaImmagine}
                    onClose={this.showConfirmPanelElimina} />
            </div >
        );
    }
};
function mapStateToProps(state) {
    return {
        microCategorie: state.microCategorie.detailsMC,
        listaGaranzie: state.microCategorie.listGaranzie,
        ramiSelezionabili: state.microCategorie.ramiSelezionabili,
        gruppiRamoSelezionabili: state.microCategorie.gruppiRamoSelezionabili,
        showConfirm: state.app.showPopUp,
        contraenti: state.microCategorie.contraenti,
        tabSelected: state.microCategorie.tabSelected,
        ramoSinistri: state.microCategorie.ramoSinistri,
        tipoProposta: state.microCategorie.tipoProposta,
    }
}

function mapDispatchToProps(dispatch) {
    return {

        salvaGP(history) {
            return dispatch(MicroCategorieActions.salvaGP(history));
        },
        handleChange(index, e) {
            return dispatch(MicroCategorieActions.handleChange(index, e))
        },
        inizializzaCreazioneGP(modifica) {
            return dispatch(MicroCategorieActions.inizializzaCreazioneGP(modifica));
        },
        getListaGaranzie() {
            return dispatch(MicroCategorieActions.getListaGaranzie());
        },
        removeSelectedRow(row) {
            return dispatch(MicroCategorieActions.removeSelectedRow(row));
        },
        spostaSelectedRowGiu(row) {
            return dispatch(MicroCategorieActions.spostaSelectedRowGiu(row));
        },
        spostaSelectedRowSu(row) {
            return dispatch(MicroCategorieActions.spostaSelectedRowSu(row));
        },
        inizializzaNuovaGaranziaDalGP() {
            return dispatch(GaranzieActions.inizializzaNuovaGaranziaDalGP())
        },
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },
        inizializzaComboRami() {
            return dispatch(MicroCategorieActions.inizializzaComboRami());
        },
        impostaCampiSuperioriMicroCategorie(campo) {
            return dispatch(MicroCategorieActions.impostaCampiSuperioriMicroCategorie(campo));
        },
        downloadImage() {
            return dispatch(MicroCategorieActions.downloadImage())
        },
        inizializzaModificaContraenti() {
            return dispatch(MicroCategorieActions.inzializzaModificaContraenti())
        },

        changeSelectedTab(idTab) {
            return dispatch(MicroCategorieActions.changeSelectedTab(idTab));
        },

        getListaRamoSinistri() {
            return dispatch(MicroCategorieActions.getListaRamoSinistri());
        },

        deleteMicroCategoriaImmagine() {
            return dispatch(MicroCategorieActions.deleteMicroCategoriaImmagine());
        },

        inzializzaModificaTipoProposta() {
            return dispatch(MicroCategorieActions.inzializzaModificaTipoProposta())
        },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MicroCategorieCreate);